"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var _react=require("react"),ReactReduxFirebaseContext=(0,_react.createContext)(null),_default=ReactReduxFirebaseContext;exports.default=_default,module.exports=exports.default;
//# sourceMappingURL=ReactReduxFirebaseContext.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-firebase/lib/ReactReduxFirebaseContext.js
// module id = 68
// module chunks = 0